import React, { Fragment } from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

const Layout = dynamic(() => import('../Layout'));
const WpBar = dynamic(() => import('../WpBar'), { ssr: false });
const Error404 = dynamic(() => import('../../screens/Error/404'));
const ErrorDefault = dynamic(() => import('../../screens/Error/ErrorDefault'));
const Offline = dynamic(() => import('../../screens/Offline'));

function Error({ statusCode, offline, wpLoggedIn, ...props }) {
  return (
    <Fragment>
      <WpBar wpLoggedIn={wpLoggedIn} />
      <Layout>
        {(() => {
          switch (statusCode) {
            case 404: {
              return <Error404 {...props} />;
            }
            case 801: {
              return <Offline {...props} />;
            }
            default: {
              return <ErrorDefault {...props} statusCode={statusCode} />;
            }
          }
        })()}
      </Layout>
    </Fragment>
  );
}

Error.propTypes = {
  statusCode: PropTypes.number,
  offline: PropTypes.bool,
  wpLoggedIn: PropTypes.bool,
};

export default Error;
